
// 0门诊 1微信 2电话 3其他
export enum RecipeState {
  YDJ = '1',
  WDJ = `0`,
  TFDSP = '2',
  TGSPDTF = '3',
  YTF = '5',  
}

export const RecipeStateList = [
  RecipeState.YDJ,
  RecipeState.WDJ,
  RecipeState.TFDSP,
  RecipeState.TGSPDTF,
  RecipeState.YTF,
]

export function getRecipeState(recipeState: string): string {
  switch (recipeState) {
    case "1":
      return '已代煎'
    case "0":
      return "未代煎"
    case "2":
      return "退费待审批"
    case "3":
      return "通过审批待退费"
    case "5":
      return "已退费"
  }
  return "-"
}